import ServiceDetail from '@/pages/ServiceDetail';

export default function MobileServiceDetailScreen() {
  return <ServiceDetail />;
}

